import script from "./SimpleCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleCarousel.vue?vue&type=script&setup=true&lang=js"

import "./SimpleCarousel.vue?vue&type=style&index=0&id=4e412224&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e412224"]])

export default __exports__